module.exports = __webpack_public_path__ + "static/media/reading-emotions.2af494da.jpg";